/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetPasskeyOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPasskeyOptionsQuery = (
  { __typename?: 'Query' }
  & { createPasskeyRegisterOptions: (
    { __typename?: 'PasskeyRegisterOptions' }
    & Pick<Types.PasskeyRegisterOptions, 'challenge' | 'timeout' | 'hints' | 'attestation' | 'attestationFormats'>
    & { rp: (
      { __typename?: 'PublicKeyCredentialRpEntity' }
      & Pick<Types.PublicKeyCredentialRpEntity, 'id' | 'name'>
    ), user: (
      { __typename?: 'PublicKeyCredentialUserEntity' }
      & Pick<Types.PublicKeyCredentialUserEntity, 'id' | 'name' | 'displayName'>
    ), pubKeyCredParams: Array<(
      { __typename?: 'PublicKeyCredentialParameters' }
      & Pick<Types.PublicKeyCredentialParameters, 'alg' | 'type'>
    )>, excludeCredentials: Array<(
      { __typename?: 'PublicKeyCredentialDescriptor' }
      & Pick<Types.PublicKeyCredentialDescriptor, 'id' | 'type' | 'transports'>
    )>, authenticatorSelection: (
      { __typename?: 'AuthenticatorSelectionCriteria' }
      & Pick<Types.AuthenticatorSelectionCriteria, 'authenticatorAttachment' | 'requireResidentKey' | 'residentKey' | 'userVerification'>
    ) }
  ) }
);


export const GetPasskeyOptionsDocument = gql`
    query GetPasskeyOptions {
  createPasskeyRegisterOptions {
    rp {
      id
      name
    }
    user {
      id
      name
      displayName
    }
    challenge
    pubKeyCredParams {
      alg
      type
    }
    timeout
    excludeCredentials {
      id
      type
      transports
    }
    authenticatorSelection {
      authenticatorAttachment
      requireResidentKey
      residentKey
      userVerification
    }
    hints
    attestation
    attestationFormats
  }
}
    `;

/**
 * __useGetPasskeyOptionsQuery__
 *
 * To run a query within a React component, call `useGetPasskeyOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPasskeyOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPasskeyOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPasskeyOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPasskeyOptionsQuery, GetPasskeyOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPasskeyOptionsQuery, GetPasskeyOptionsQueryVariables>(GetPasskeyOptionsDocument, options);
      }
export function useGetPasskeyOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPasskeyOptionsQuery, GetPasskeyOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPasskeyOptionsQuery, GetPasskeyOptionsQueryVariables>(GetPasskeyOptionsDocument, options);
        }
export type GetPasskeyOptionsQueryHookResult = ReturnType<typeof useGetPasskeyOptionsQuery>;
export type GetPasskeyOptionsLazyQueryHookResult = ReturnType<typeof useGetPasskeyOptionsLazyQuery>;
export type GetPasskeyOptionsQueryResult = Apollo.QueryResult<GetPasskeyOptionsQuery, GetPasskeyOptionsQueryVariables>;